import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ServicesHelper } from '../helpers/services.helper';
import { Observable } from 'rxjs';
import { BlackListHistoric } from '../models';

@Injectable()
export class BlackListHistoricService {
  private url: string;
  constructor(private httpClient: HttpClient, @Inject('API_URL') private apiUrl: string) {
    this.url = apiUrl + 'blackListHistoric/';
  }

  get(id: string): Observable<Array<BlackListHistoric>> {
    const url: string = this.url + id;
    const response: Observable<Array<BlackListHistoric>> = this.httpClient.get<Array<BlackListHistoric>>(url, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }

  saveEntity(entity: BlackListHistoric) {
    const url: string = this.url;
    const response: Observable<any> = this.httpClient.put<any>(url, entity, {
      responseType: 'json',
      headers: ServicesHelper.getHeaders(),
    });
    return response;
  }
}
